import React, {useState} from 'react';
import paymentActions from "../../store/actions/payment";
import {useDispatch, useSelector} from "react-redux";
import PaymentSteps from "./PaymentSteps";

const Payment = () => {
    const paymentStore = useSelector((store) => store.paymentStore);
    const dispatch = useDispatch();

    const [tipOpen, setTipOpen] = useState(false);
    const [accountNumberError, setAccountNumberError] = useState('');
    const [zipCodeError, setZipCodeError] = useState('');

    const reg_ex = /^[0-9]*\.?[0-9]*$/;

    const openTooltip = () => {
        setTipOpen(!tipOpen);
    }

    const setFormAccountNumber = (value) => {
        if (value === '' || value.match(reg_ex)){
            dispatch(paymentActions.setFormAccountNumber(value));
            setAccountNumberError('');
        }
    }
    const setFormZipCode = (value) => {
        value = value.replace('-','');
        if (value === '' || value.match(reg_ex)){
            value = value.substring(0, 9);
            if (value.length > 5) {
                value = [value.slice(0, 5), '-', value.slice(5)].join('');
            }
            dispatch(paymentActions.setFormZipCode(value));
            setZipCodeError('');
        }
    }

    const formSubmit = (event) => {
        event.preventDefault();

        let formValid = true;
        dispatch(paymentActions.setFormError(''));

        if (paymentStore.formAccountNumber.length < 5) {
            setAccountNumberError('Enter account number');
            formValid = false;
        }
        if (paymentStore.formZipCode.length < 10 && paymentStore.formZipCode.length !== 5) {
            setZipCodeError('Enter zip code (5-9 characters)');
            formValid = false;
        }

        if (formValid) {
            dispatch(paymentActions.sendFormAccountVerification(
                paymentStore.formAccountNumber,
                paymentStore.formZipCode,
            ));
        }

    }

    return (
        <div className="payment">
            <div className="modal modal-payment">
                <div className="modal-block">
                    <button
                        type='button'
                        className='modal-close'
                        onClick={() => dispatch(paymentActions.closePayment())}
                    >
                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-an-agent/close.svg`} alt="close"/>
                    </button>
                    <div className="modal-content">
                        <div className="modal-heading">
                            <div className="modal-title">Make a Payment</div>
                        </div>
                        <form onSubmit={(ev) => {formSubmit(ev)}} className="form">
                            <div className={`form-group ${accountNumberError.length > 0 ? 'error' : ''}`}>
                                <div className="label">
                                    Account Number
                                    <div className={`info-container ${tipOpen ? 'open' : ''}`}>
                                        <span className="info-container__icon" onTouchStart={() => {openTooltip()}}>
                                          <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/make-payment/info.svg`}/>
                                        </span>
                                        <div className="popup">
                                            <div className="popup__square"/>
                                            <h3 className="popup__title">
                                                Find your account number at the top of your invoice.
                                            </h3>
                                            <div className="popup__img">
                                                <img className="form-tooltip__icon" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/make-payment/payment-info.jpg`}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <input
                                    placeholder='Enter account number'
                                    className='form-input'
                                    onChange={(ev) => setFormAccountNumber(ev.target.value)}
                                    value={paymentStore.formAccountNumber}
                                />
                                {accountNumberError.length > 0 &&
                                    <div className="input-error">{accountNumberError}</div>
                                }
                            </div>
                            <div className={`form-group zip-code ${zipCodeError.length > 0 ? 'error' : ''}`}>
                                <div className="label">Billing Zip Code</div>
                                <input
                                    placeholder='Enter your billing zip code'
                                    className='form-input'
                                    onChange={(ev) => setFormZipCode(ev.target.value)}
                                    value={paymentStore.formZipCode}
                                />
                                {zipCodeError.length > 0 &&
                                <div className="input-error">{zipCodeError}</div>
                                }
                            </div>
                            <div className="form-tooltip">
                                <img className="form-tooltip__icon" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/make-payment/info.svg`}/>
                                <p className="form-tooltip__text">
                                    Payments to accounts that are past due may still result in cancellation.
                                    If your account is past due, please call Customer Service at <a href="tel:18007923084">1-800-792-3084</a> to ensure continued
                                    coverage.
                                </p>
                            </div>
                            <button type='submit' className={`form-submit button-gradient ${paymentStore.isAccountFormLoading ? 'is-loading' : ''}`}>
                                <span>Send</span>
                            </button>
                            <div className="form-error">{paymentStore.formError}</div>
                        </form>
                    </div>
                </div>
                <div className="modal-overlay" onClick={() => dispatch(paymentActions.closePayment())} />
            </div>
            {paymentStore.paymentStepsOpen && <PaymentSteps/>}
        </div>
    )
};

export default Payment;
